import {extend} from 'quasar';

export class AuthToken {
    // tslint:disable-next-line
    public access_token = '';
    // tslint:disable-next-line
    public token_type = '';
    // tslint:disable-next-line
    public refresh_token = '';
    // tslint:disable-next-line
    public expires_in = 0;
    public scope = '';
    public jti = '';

    public static of(o: any) {
        const at = extend(new AuthToken(), o) as AuthToken;
        return at;
    }

    public getAccessTokenWithBearer() {
        return 'Bearer ' + this.access_token;
    }

    public getRefreshTokenWithBearer() {
        return 'Bearer ' + this.refresh_token;
    }

    public getClam(): string {
        const strings = this.access_token.split('.');
        const s = atob(strings[1]);
        if (s !== '') {
            return JSON.parse(s);
        }
        return '';
    }

    public getUsername() {
        const clam = this.getClam() as any;
        const userName: string = clam.user_name;
        return userName;

    }

    public getAuthority() {
        const clam = this.getClam() as any;
        const authorities: string = clam.authorities;
        return authorities;
    }

    public getAuthoritys(): string[] {
        const clam = this.getClam() as any;
        return clam.authorities;

    }
}
